(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-media"] && !Shopify.designMode) return;
  try {
    
  var BMS_DUREE = 500;
  var BMS_COURBE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  function bmsInitRail(rail) {
    var track = rail.querySelector('[data-bms]');
    if (!track || track.dataset.bmsReady) return;
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;
    track.dataset.bmsReady = 'true';

    var n = slides.length;
    var fill = rail.querySelector('.bms__bar-fill');
    var prev = rail.querySelector('.bms__nav--prev');
    var next = rail.querySelector('.bms__nav--next');
    var active = 0;
    var enCours = false;
    var animable = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var BMS_BARRE = 48;
    var largeurPastille = n === 3 ? 18 : Math.max(8, Math.round(BMS_BARRE / Math.max(n, 1)));
    var course = BMS_BARRE - largeurPastille;
    if (fill) fill.style.width = largeurPastille + 'px';

    function appliquer() {
      for (var i = 0; i < n; i++) {
        slides[i].style.order = (i - active + n) % n;
        slides[i].classList.toggle('is-active', i === active);
      }
      if (fill) {
        var t = n > 1 ? (active / (n - 1)) * course : 0;
        fill.style.transform = 'translateX(' + t + 'px)';
      }
    }

    function mesurer() {
      var base = track.getBoundingClientRect();
      return slides.map(function (s) {
        var r = s.getBoundingClientRect();
        return { l: r.left - base.left, t: r.top - base.top, w: r.width, h: r.height };
      });
    }

    function liberer() {
      track.style.height = '';
      track.style.position = '';
      slides.forEach(function (s) {
        s.style.transition = '';
        s.style.position = '';
        s.style.left = ''; s.style.top = '';
        s.style.width = ''; s.style.height = '';
        s.style.transform = '';
        s.style.willChange = '';
      });
      enCours = false;
    }

    function aller(suivant) {
      if (enCours || suivant === active) return;
      if (!animable) { active = suivant; appliquer(); return; }
      enCours = true;

      var avant = mesurer();
      var hauteur = track.getBoundingClientRect().height;

      slides.forEach(function (s) { s.style.transition = 'none'; });
      active = suivant;
      appliquer();
      void track.offsetHeight;
      var apres = mesurer();

      track.style.height = hauteur + 'px';
      track.style.position = 'relative';
      slides.forEach(function (s, i) {
        var a = avant[i], b = apres[i];
        s.style.transition = 'none';
        s.style.position = 'absolute';
        s.style.left = b.l + 'px';
        s.style.top = b.t + 'px';
        s.style.width = a.w + 'px';
        s.style.height = a.h + 'px';
        s.style.transform = 'translate(' + (a.l - b.l) + 'px,' + (a.t - b.t) + 'px)';
        s.style.willChange = 'transform, width, height';
      });

      void track.offsetHeight;

      slides.forEach(function (s, i) {
        var b = apres[i];
        s.style.transition =
          'transform ' + BMS_DUREE + 'ms ' + BMS_COURBE + ', ' +
          'width ' + BMS_DUREE + 'ms ' + BMS_COURBE + ', ' +
          'height ' + BMS_DUREE + 'ms ' + BMS_COURBE;
        s.style.transform = 'translate(0,0)';
        s.style.width = b.w + 'px';
        s.style.height = b.h + 'px';
      });
      setTimeout(liberer, BMS_DUREE + 30);
    }

    if (prev) prev.addEventListener('click', function () { aller((active - 1 + n) % n); });
    if (next) next.addEventListener('click', function () { aller((active + 1) % n); });
    appliquer();
  }

  function bmsBoot() {
    document.querySelectorAll('.bms__rail').forEach(bmsInitRail);
  }

  if (document.readyState !== 'loading') { bmsBoot(); }
  else { document.addEventListener('DOMContentLoaded', bmsBoot); }
  document.addEventListener('shopify:section:load', bmsBoot);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements && customElements.get('collection-carousel')) return;

    var MOBILE = '(max-width: 989px)';

    class CollectionCarousel extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        this._mq = window.matchMedia(MOBILE);
        this._sync = this._sync.bind(this);

        if (typeof Swiper !== 'undefined') this._sync();
        else window.addEventListener('load', this._sync, { once: true });

        if (this._mq.addEventListener) this._mq.addEventListener('change', this._sync);
        else if (this._mq.addListener) this._mq.addListener(this._sync);
      }

      _sync() {
        if (typeof Swiper === 'undefined') return;
        if (this._mq.matches) this._boot();
        else this._destroy();
      }

      _boot() {
        if (this._swiper) return;
        var el = this.querySelector('[data-wc-swiper]');
        if (!el || !el.querySelector('.shopify-block')) return;

        this._swiper = new Swiper(el, {
          slideClass: 'shopify-block',
          slidesPerView: 'auto',
          spaceBetween: 12,
          watchSlidesProgress: true,
          grabCursor: true,
          observer: true,
          observeParents: true,
          keyboard: { enabled: true },
          navigation: {
            prevEl: this.querySelector('[data-wc-prev]'),
            nextEl: this.querySelector('[data-wc-next]')
          },
          scrollbar: {
            el: this.querySelector('[data-wc-bar]'),
            draggable: true
          }
        });
      }

      _destroy() {
        if (!this._swiper) return;
        this._swiper.destroy(true, true);
        this._swiper = null;
      }

      disconnectedCallback() {
        this._destroy();
        if (this._mq) {
          if (this._mq.removeEventListener) this._mq.removeEventListener('change', this._sync);
          else if (this._mq.removeListener) this._mq.removeListener(this._sync);
        }
        this._init = false;
      }
    }

    customElements.define('collection-carousel', CollectionCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function docBuild(root) {
      if (root.dataset.docReady) return;
      root.dataset.docReady = 'true';

      var nav = root.querySelector('[data-doc-nav]');
      var chapters = root.querySelectorAll('[data-doc-chapter]');
      if (!nav || !chapters.length) return;

      var links = [];
      var map = {};
      Array.prototype.forEach.call(chapters, function (ch, i) {
        var group = ch.getAttribute('data-doc-group');
        if (group) {
          var g = document.createElement('span');
          g.className = 'doc__nav-group';
          g.textContent = group;
          nav.appendChild(g);
        }
        var id = ch.id || 'doc-ch-' + i;
        ch.id = id;
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = ch.getAttribute('data-doc-title') || '';
        nav.appendChild(a);
        links.push(a);
        map[id] = a;
      });

      root.querySelectorAll('[data-doc-count]').forEach(function (slot) {
        var key = slot.getAttribute('data-doc-count');
        var n = root.querySelectorAll('[data-doc-status="' + key + '"]').length;
        var one = slot.getAttribute('data-doc-singular') || '';
        var many = slot.getAttribute('data-doc-plural') || one;
        slot.textContent = n + ' ' + (n > 1 ? many : one);
        var item = slot.closest('.doc-legend__item');
        if (item && n === 0) item.hidden = true;
      });

      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) { a.classList.remove('is-current'); });
          if (map[e.target.id]) map[e.target.id].classList.add('is-current');
        });
      }, { rootMargin: '-10% 0px -75% 0px' });
      Array.prototype.forEach.call(chapters, function (ch) { obs.observe(ch); });
    }

    function docBoot() {
      document.querySelectorAll('[data-doc]').forEach(docBuild);
    }

    if (document.readyState !== 'loading') { docBoot(); }
    else { document.addEventListener('DOMContentLoaded', docBoot); }
    document.addEventListener('shopify:section:load', docBoot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  function ppStickyInit(form) {
    var barre = form.querySelector('[data-pp-sticky]');
    if (!barre) return;
    var reference = form.querySelector('.pp-buy [data-pp-add]') || form.querySelector('.pp-buy');
    if (!reference) return;

    if (barre.ppStickyBound) {
      barre.ppStickyBound.abort();
    }
    var ctrl = new AbortController();
    barre.ppStickyBound = ctrl;

    var panneau = form.querySelector('.pp-options-drawer');
    var reservoir = panneau && panneau.querySelector('[data-pp-options-slot]');
    if (panneau && reservoir) {
      panneau.addEventListener('w-drawer:open', function () {
        reservoir.replaceChildren();
        form.querySelectorAll('.pp-step').forEach(function (noeud) {
          if (panneau.contains(noeud)) return; // jamais se recopier soi-meme
          var clone = noeud.cloneNode(true);
          clone.removeAttribute('id');
          clone.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
          reservoir.appendChild(clone);
        });
        if (typeof form.initCarousels === 'function') form.initCarousels();

        var inner = barre.querySelector('.pp-sticky__inner') || barre;
        var rb = inner.getBoundingClientRect();
        panneau.style.setProperty('--pp-panel-right', (window.innerWidth - rb.right) + 'px');
        panneau.style.setProperty('--pp-panel-bottom', (window.innerHeight - rb.top + 6) + 'px');
      }, { signal: ctrl.signal });
      document.addEventListener('cart:add', function () {
        if (panneau.classList.contains('is-open')) panneau.close();
      }, { signal: ctrl.signal });

      panneau.addEventListener('w-drawer:close', function () {
        reservoir.querySelectorAll('[data-pp-swiper]').forEach(function (el) {
          if (el.swiper) { el.swiper.destroy(true, true); el.swiper = null; }
        });
        reservoir.replaceChildren();
      }, { signal: ctrl.signal });
    }

    var enAttente = false;

    function appliquer() {
      enAttente = false;
      if (!form.isConnected || !reference.isConnected) return;
      var depasse = reference.getBoundingClientRect().bottom <= 0;
      if (depasse === barre.classList.contains('is-visible')) return;
      if (depasse) {
        barre.hidden = false;
        void barre.offsetHeight;
        barre.classList.add('is-visible');
      } else {
        barre.classList.remove('is-visible');
      }
    }

    function planifier() {
      if (enAttente) return;
      enAttente = true;
      window.requestAnimationFrame(appliquer);
    }

    window.addEventListener('scroll', planifier, { passive: true, signal: ctrl.signal });
    window.addEventListener('resize', planifier, { passive: true, signal: ctrl.signal });
    appliquer();
  }

  function ppStickyBoot() {
    document.querySelectorAll('product-form[data-pp-form]').forEach(ppStickyInit);
  }

  if (document.readyState !== 'loading') ppStickyBoot();
  else document.addEventListener('DOMContentLoaded', ppStickyBoot);
  document.addEventListener('shopify:section:load', ppStickyBoot);
  document.addEventListener('pp:switched', ppStickyBoot);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-app"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function propre(t) { return (t || '').replace(/\s+/g, ' ').trim(); }

    function alimenter(section) {
      var maison = section.querySelector('[data-rva-head]');
      var entete = section.querySelector('.jdgm-rev-widg__header');
      if (!maison || !entete) return false;

      var moyenneTxt = propre(entete.querySelector('.jdgm-rev-widg__summary-average') ?
        entete.querySelector('.jdgm-rev-widg__summary-average').textContent : '');
      if (!moyenneTxt) return false;

      var n = parseFloat(moyenneTxt.replace(',', '.'));
      var champMoyenne = maison.querySelector('[data-rva-average]');
      if (champMoyenne && !isNaN(n)) champMoyenne.textContent = n.toFixed(1).replace('.', ',') + '/5';

      var resume = entete.querySelector('.jdgm-rev-widg__summary-text');
      var champCompte = maison.querySelector('[data-rva-count]');
      if (champCompte && resume) champCompte.textContent = propre(resume.textContent);

      var arrondi = isNaN(n) ? 0 : Math.round(n);
      var etoiles = maison.querySelectorAll('[data-rva-star]');
      for (var e = 0; e < etoiles.length; e++) {
        var rang = parseInt(etoiles[e].getAttribute('data-rva-star'), 10);
        etoiles[e].classList.toggle('is-on', rang <= arrondi);
      }
      var groupe = maison.querySelector('[data-rva-stars]');
      if (groupe && !isNaN(n)) groupe.setAttribute('aria-label', 'Note : ' + n.toFixed(1) + ' sur 5');

      var lignes = section.querySelectorAll('.jdgm-histogram__row[data-rating]');
      for (var i = 0; i < lignes.length; i++) {
        var note = lignes[i].getAttribute('data-rating');
        if (!note || note === 'null') continue;
        var cible = maison.querySelector('[data-rva-row="' + note + '"]');
        if (!cible) continue;

        var freq = lignes[i].querySelector('.jdgm-histogram__frequency');
        var champFreq = cible.querySelector('[data-rva-frequency]');
        if (freq && champFreq) champFreq.textContent = '(' + propre(freq.textContent) + ')';

        var barre = lignes[i].querySelector('.jdgm-histogram__bar-content');
        var remplissage = cible.querySelector('[data-rva-fill]');
        if (barre && remplissage) {
          var m = (barre.getAttribute('style') || '').match(/width:\s*([\d.]+)%/);
          if (m) remplissage.style.width = m[1] + '%';
        }
      }

      entete.setAttribute('data-rva-remplace', '');
      maison.hidden = false;
      return true;
    }

    function masquerRangsVides(section) {
      var rangs = section.querySelectorAll('.jdgm-row-extra');
      for (var i = 0; i < rangs.length; i++) {
        rangs[i].hidden = propre(rangs[i].textContent) === '';
      }
    }

    function brancher(section) {
      var maison = section.querySelector('[data-rva-head]');
      if (!maison || maison.dataset.rvaBranche) return;
      maison.dataset.rvaBranche = '1';

      var bouton = maison.querySelector('[data-rva-write]');
      if (bouton) {
        bouton.addEventListener('click', function () {
          var vrai = section.querySelector('.jdgm-write-rev-link');
          if (vrai) vrai.click();
        });
      }

      var lignes = maison.querySelectorAll('[data-rva-row]');
      for (var i = 0; i < lignes.length; i++) {
        (function (ligne) {
          function relayer() {
            var note = ligne.getAttribute('data-rva-row');
            var cible = section.querySelector('.jdgm-histogram__row[data-rating="' + note + '"]');
            if (cible) cible.click();
          }
          ligne.addEventListener('click', relayer);
          ligne.addEventListener('keydown', function (ev) {
            if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); relayer(); }
          });
        })(lignes[i]);
      }
    }

    function demarrer(section) {
      brancher(section);
      alimenter(section);
      masquerRangsVides(section);
      var obs = new MutationObserver(function () {
        window.requestAnimationFrame(function () {
          alimenter(section);
          masquerRangsVides(section);
        });
      });
      obs.observe(section, { childList: true, subtree: true });
    }

    function init() {
      var sections = document.querySelectorAll('[data-section-type="reviews-app"]');
      for (var i = 0; i < sections.length; i++) demarrer(sections[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["w-blog"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var bouton = event.target.closest('[data-w-blog-more]');
    if (!bouton) return;
    var racine = bouton.closest('.w-blog');
    var grille = racine && racine.querySelector('.w-blog__grid');
    if (!grille) return;
    grille.classList.add('is-expanded');
    bouton.remove();
  });

  } catch(e) { console.error(e); }
})();
})();
